<div class="head">
  <h1 class="page-title">Budgets</h1>
  <button class="btn" (click)="suggest()">Suggest from your last 6 months</button>
  <div class="month-nav">
    <button class="step" (click)="prevMonth()" [disabled]="!canGoBack" aria-label="Previous month">‹</button>
    <!-- monthLabel returns '' (empty string) when there is no month, so || is required here; ?? would render blank. -->
    <span class="month">{{ monthLabel || 'No data' }}</span>
    <button class="step" (click)="nextMonth()" [disabled]="!canGoForward" aria-label="Next month">›</button>
  </div>
</div>

<p class="hint suggest-hint" *ngIf="suggested.size">
  {{ suggested.size }} draft suggestion{{ suggested.size === 1 ? '' : 's' }} — leaving a field saves it,
  or
  <button class="btn" (click)="saveSuggestions()">Save suggestions</button>
  to save the rest at once.
</p>

<p class="loading" *ngIf="loading">Loading…</p>
<p class="error" *ngIf="error">{{ error }}</p>

<ng-container *ngIf="!loading">
  <div class="lbl">By group</div>
  <p class="empty" *ngIf="!rollup.length">No budgets set yet. Add one below.</p>
  <div class="grow" *ngFor="let g of rollup; trackBy: trackGroupRow">
    <span class="sw" [style.background]="g.color"></span>
    <span class="gname">{{ g.groupName }}</span>
    <span class="track"><span class="fill" [class.over]="g.isOver"
          [style.width.%]="g.pctUsed" [style.background]="g.isOver ? null : g.color"></span></span>
    <span class="nums" [class.over]="g.isOver">{{ fmt(g.spentCents) }} / {{ fmt(g.limitCents) }}</span>
  </div>

  <div class="lbl second">By category</div>
  <ng-container *ngFor="let cg of categoryGroups; trackBy: trackCategoryGroup">
    <div class="gheading">
      <span class="sw" [style.background]="cg.group.color"></span>
      {{ cg.group.name }}
    </div>
    <div class="crow" *ngFor="let c of cg.categories; trackBy: trackCategory">
      <span class="cname">
        <span class="cname-text">{{ c.name }}</span>
        <span class="override-tag" *ngIf="isOverridden(c.id)" [title]="monthLabel + ' uses an override, not the default'">override</span>
      </span>

      <ng-container *ngIf="rowFor(c.id) as r">
        <span class="track"><span class="fill" [class.over]="r.isOver" [style.width.%]="r.pctUsed"></span></span>
        <span class="nums" [class.over]="r.isOver">{{ fmt(r.spentCents) }} / {{ fmt(r.limitCents) }}</span>
      </ng-container>
      <span class="track placeholder" *ngIf="!rowFor(c.id)"></span>

      <span class="input-col">
        <span class="input-cap">default</span>
        <span class="input-wrap">
          <span class="dollar">$</span>
          <input class="amount" type="number" min="0" inputmode="numeric"
                 [class.suggested]="suggested.has(c.id)"
                 [(ngModel)]="draft[c.id]"
                 (blur)="save(c.id)" (keyup.enter)="save(c.id)"
                 placeholder="—">
        </span>
      </span>

      <span class="input-col">
        <span class="input-cap" [class.active]="isOverridden(c.id)">this month</span>
        <span class="input-wrap override-wrap" [class.active]="isOverridden(c.id)">
          <span class="dollar">$</span>
          <input class="amount" type="number" min="0" inputmode="numeric"
                 [(ngModel)]="overrideDraft[c.id]"
                 (blur)="saveOverride(c.id)" (keyup.enter)="saveOverride(c.id)"
                 [attr.aria-label]="'Override for ' + monthLabel"
                 placeholder="default">
        </span>
      </span>
    </div>
  </ng-container>
</ng-container>
